var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendGreenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16687_29127)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9594 1.27178C18.0003 1.16955 18.0103 1.05757 17.9882 0.94971C17.966 0.84185 17.9128 0.742854 17.8349 0.664997C17.757 0.58714 17.658 0.533844 17.5502 0.511718C17.4423 0.489593 17.3303 0.499609 17.2281 0.540526L0.862742 7.0869H0.861617L0.353117 7.2894C0.256806 7.32782 0.172988 7.39211 0.110922 7.47517C0.0488559 7.55824 0.0109572 7.65684 0.00141206 7.76009C-0.00813305 7.86334 0.011047 7.96722 0.0568335 8.06025C0.10262 8.15329 0.173231 8.23185 0.260867 8.28728L0.722117 8.57978L0.723242 8.58203L6.34262 12.1573L9.91787 17.7767L9.92012 17.7789L10.2126 18.2402C10.2682 18.3275 10.3468 18.3977 10.4398 18.4432C10.5328 18.4887 10.6365 18.5077 10.7395 18.498C10.8426 18.4884 10.941 18.4505 11.0239 18.3885C11.1068 18.3265 11.1709 18.2429 11.2094 18.1468L17.9594 1.27178ZM15.8972 3.39803L7.46649 11.8288L7.22462 11.4485C7.1803 11.3787 7.12114 11.3196 7.05137 11.2753L6.67112 11.0334L15.1019 2.60265L16.4271 2.07278L15.8972 3.39803Z",
    fill: "#328734"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16687_29127"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendGreenIcon);
export default __webpack_public_path__ + "static/media/send_green_icon.e42b9a65b61d652995d7d4283c7c6eb5.svg";
export { ForwardRef as ReactComponent };